// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3nxtV","search":"Settings_search__3uOeC","filter":"Settings_filter__UJJuh"};